import { useEffect, useState } from "react";
import { getRemainingSessionMs, isSessionExpired } from "../../auth/sessionExpiry";

export default function SessionTimer() {
    const [timeLeft, setTimeLeft] = useState<number>(0);

    useEffect(() => {
        const updateTimeLeft = () => {
            if (isSessionExpired()) {
                setTimeLeft(0);
                return;
            }
            const remaining = getRemainingSessionMs();
            setTimeLeft(remaining ?? 0);
        };

        updateTimeLeft();
        const intervalId = window.setInterval(updateTimeLeft, 1000);

        const onVisible = () => {
            if (document.visibilityState === "visible") {
                updateTimeLeft();
            }
        };
        window.addEventListener("focus", updateTimeLeft);
        document.addEventListener("visibilitychange", onVisible);

        return () => {
            window.clearInterval(intervalId);
            window.removeEventListener("focus", updateTimeLeft);
            document.removeEventListener("visibilitychange", onVisible);
        };
    }, []);

    const formatTime = (time: number) => {
        const hours = Math.floor(time / 3600000);
        const minutes = Math.floor((time % 3600000) / 60000);
        const seconds = Math.floor((time % 60000) / 1000);
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    return (
        <span style={{ fontWeight: 'bold', fontSize: '1.1rem', color: 'rgb(26, 29, 38)' }}>
            {formatTime(timeLeft)}
        </span>
    );
}
